<template>

    <v-dialog
        @input="$emit('show', $event)"
        :value="value"
        persistent
        width="500">
        <v-card>
            <v-card-title>
                Are you sure you want to delete
            </v-card-title>
            <v-card-actions>
                <v-btn
                    @click="handelYes">
                    Yes
                </v-btn>
                <v-btn
                    @click="handelNo">
                    No
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "DeleteDesisionDialog",
    props: {
        value:Boolean
    },
    methods: {
        handelYes() {
            this.$emit('yes')
        },
        handelNo() {
            this.$emit('no')
        }
    }

}
</script>

<style>

</style>